/** Used when /api/accounts/roles returns empty or fails (live DB issue). */
export const FALLBACK_SIGNUP_ROLES = [
  { id: 1, name: "HR (Menneskelige ressourcer)", value: "HR (Menneskelige ressourcer)" },
  { id: 2, name: "Marketing (Markedsføring)", value: "Marketing (Markedsføring)" },
  { id: 3, name: "Accounting (Regnskab)", value: "Accounting (Regnskab)" },
  { id: 4, name: "Production (Produktion)", value: "Production (Produktion)" },
  { id: 5, name: "Logistics (Logistik)", value: "Logistics (Logistik)" },
  { id: 6, name: "IT (Informationsteknologi)", value: "IT (Informationsteknologi)" },
  { id: 7, name: "Sales (Salg)", value: "Sales (Salg)" },
  { id: 8, name: "Supply Chain (Forsyningskæde)", value: "Supply Chain (Forsyningskæde)" },
  { id: 9, name: "Admin", value: "Admin" },
  {
    id: 10,
    name: "Ownership & Board (Ejerskab og bestyrelse)",
    value: "Ownership & Board (Ejerskab og bestyrelse)",
  },
  { id: 12, name: "Facilities Management (Facilitetsstyring)", value: "Facilities Management (Facilitetsstyring)" },
  { id: 13, name: "Real Estate (Ejendom)", value: "Real Estate (Ejendom)" },
];

/**
 * Signup country options with ISO codes for VAT/CVR lookup.
 * useCvr: Danish CVR registry; otherwise EU VIES when code is set.
 */
export const SIGNUP_COUNTRIES = [
  { name: "Denmark", code: "DK", useCvr: true },
  { name: "Sweden", code: "SE" },
  { name: "Norway", code: "NO" },
  { name: "Finland", code: "FI" },
  { name: "Germany", code: "DE" },
  { name: "Netherlands", code: "NL" },
  { name: "Belgium", code: "BE" },
  { name: "France", code: "FR" },
  { name: "United Kingdom", code: "GB" },
  { name: "Ireland", code: "IE" },
  { name: "Austria", code: "AT" },
  { name: "Poland", code: "PL" },
  { name: "Spain", code: "ES" },
  { name: "Italy", code: "IT" },
  { name: "Portugal", code: "PT" },
  { name: "Greece", code: "EL" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Hungary", code: "HU" },
  { name: "Romania", code: "RO" },
  { name: "Bulgaria", code: "BG" },
  { name: "Croatia", code: "HR" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Estonia", code: "EE" },
  { name: "Latvia", code: "LV" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Malta", code: "MT" },
  { name: "Cyprus", code: "CY" },
  { name: "Switzerland", code: "CH" },
  { name: "Iceland", code: "IS" },
  { name: "United States", code: "US" },
  { name: "Canada", code: "CA" },
  { name: "Australia", code: "AU" },
  { name: "India", code: "IN" },
  { name: "China", code: "CN" },
  { name: "Japan", code: "JP" },
  { name: "Singapore", code: "SG" },
  { name: "Indonesia", code: "ID" },
  { name: "Brazil", code: "BR" },
  { name: "South Africa", code: "ZA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "Turkey", code: "TR" },
  { name: "Ukraine", code: "UA" },
  { name: "Other", code: null },
];

export const SIGNUP_COUNTRY_LOOKUP = Object.fromEntries(
  SIGNUP_COUNTRIES.map((c) => [c.name, c])
);

/** EU member states supported by VIES VAT lookup */
export const VIES_COUNTRY_CODES = new Set([
  "AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "EL", "ES", "FI", "FR", "HR",
  "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI",
  "SK",
]);
